export class OelType {
    id: string;
    name: string;
    description: string;
    referenceTimePeriod: number;
    deletedByUserId: string;
    deletedDate: string;
    isDeleted: boolean;
    deletedDateNormalized: string;
}